import type { ReportWithMappingDto } from '@klp/reportMapping/types';

export const getInitialValues = (reportData: ReportWithMappingDto) => {
    if (reportData.mapping) {
        return {
            byggNummer: reportData.mapping.byggNummer,
            kundenummer: reportData.mapping.kundenummer ?? '',
            reportType: reportData.mapping.reportType,
        };
    }

    return {
        byggNummer: '',
        kundenummer: '',
        reportType: '',
    };
};

export const getTranslationKeys = (isEditMode: boolean) => {
    const titleTranslationKey = isEditMode
        ? 'reportMapping.mappingEdit.titleMappingFor'
        : 'reportMapping.mappingAdd.titleMappingFor';
    const saveTranslationKey = isEditMode
        ? 'reportMapping.mappingEdit.save'
        : 'reportMapping.mappingAdd.save';

    return { titleTranslationKey, saveTranslationKey };
};
